import {useMobile} from "../../MobileContext";
import React, {useState} from "react";
import styles from "../../styles/PageLayout.module.css";
import DesktopHeader from "../../components/DesktopHeader/DesktopHeader";
import NotificationSection from "../../components/NotificationSection/NotificationSection";
import Lists from "../lists/Lists";

const AuditorLists = () => {
    const isMobile = useMobile();
    const [isNotificationPanelOpen, setIsNotificationPanelOpen] = useState(false);

    return (
        <div className={styles.mainContainer}>
            {isMobile ? (
                <> </>
            ) : (
                <DesktopHeader
                    role={"auditor"}
                    handleNotificationPanelToggle={() => setIsNotificationPanelOpen(!isNotificationPanelOpen)}
                />
            )}
            <div className={styles.contentContainer}>
                <div className={`${styles.rightSectionContainer} ${isNotificationPanelOpen ? styles.blurred : ""}`}>
                    {isMobile ? (
                        <> </>
                    ) : (
                        <Lists />
                    )}
                </div>
                {isNotificationPanelOpen &&
                    <div className={styles.notificationContainer}>
                        <NotificationSection isOpen={isNotificationPanelOpen} />
                    </div>
                }
            </div>
        </div>
    )
};

export default AuditorLists;